/* 
HELP
Its parent needs to be positioned (relative, absolute etc)

Properties
- text
- show
*/

import React from "react";
import { useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { usePopperTooltip } from "react-popper-tooltip";

import styles from './Tooltip.module.css';

const Tooltip = (props) => {
  const [textWidth, setTextWidth] = useState(10);
  const textRef = useRef(null);
  // Info tooltip with Popper package
  const {
    getArrowProps,
    getTooltipProps,
    setTooltipRef,
    setTriggerRef,
    visible,
  } = usePopperTooltip({
    interactive: true,
    // delayHide: 40
  });

  useEffect(() => {
    if (textRef && textRef.current) {
      const textLength = Object.entries(textRef.current)[0][1].stateNode.firstChild.length;
      const compStyles = window.getComputedStyle(textRef.current);
      const textFontSize = parseFloat(compStyles.fontSize.replace('px', ''));
      const pixelsPerChar = Math.ceil(textFontSize);
      const width = textLength * pixelsPerChar;
      // console.log("pixelsPerChar fontSize: ", textFontSize);
      // console.log("pixelsPerChar: ", pixelsPerChar);
      // console.log(" pixelsPerChar width: ", width);
      setTextWidth(width);
    }

  }, [textRef.current])

  return (
    <div ref={setTriggerRef} className={`${styles.infoContainer} d-flex justify-content-center`} >
      {/* TOOLTIP  */}
        {props.show && <div
          ref={setTooltipRef}
          {...getTooltipProps({className: `${styles.animated} ${styles.infoTooltip} tooltip-container` })}
        >
            {/* for the css classes used go to node_modules\react-popper-tooltip\dist\styles.css  */}
          <div {...getArrowProps({ className: `${styles.tooltipArrow} tooltip-arrow` })} />
        <p
          ref={textRef}
          style={{ width: `${textWidth}px` }}
          className={styles.text}
        >
          {props.text}
        </p>
        </div>}
    </div>
  );
}

export default Tooltip;